import './styles/Layout.scss';

import { useApolloClient } from '@apollo/client';
import { User } from '@thro-types/users';

import { memo, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import USER_QUERY from 'gql/queries/currentUser.gql';

import { actions as FormErrorActions } from 'app/containers/Dashboard/FormError/slice';
import { useBackNavigation } from 'utils/hooks/useBackNavigation';
import { useLayout } from 'utils/hooks/useLayout';
import useLocalStorage from 'utils/hooks/useLocalStorage';

import Heading from './Heading';
import { ResponiveLayoutWrapper } from './components/ResponiveLayoutWrapper';

interface Props {
  children: ReactNode;
}
export const Layout = memo((props: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isWebView] = useLocalStorage('webview', false);
  const handleBack = useBackNavigation();
  const {
    heading,
    headingLogo,
    headingProps,
    mobilePadding,
    desktopOnly,
    className,
    withoutLayout
  } = useLayout();

  const client = useApolloClient();
  const data = client.readQuery<{ currentUser: User }>({ query: USER_QUERY });

  if (isWebView) {
    return props.children;
  }

  if (withoutLayout || !data?.currentUser) {
    return <>{props.children}</>;
  }

  const renderHeading = () => {
    if (headingProps?.back) {
      return (
        <Link
          to={location.state?.back ?? headingProps.back}
          onClick={e => {
            dispatch(FormErrorActions.close());
            handleBack(e);
          }}
        >
          <Heading $back={true}>{heading}</Heading>
        </Link>
      );
    }
    if (headingLogo) {
      return (
        <div
          style={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            alignContent: 'center',
            display: 'flex'
          }}
        >
          <img
            src={headingLogo}
            alt=""
            width="30vw"
            height="30vh"
            style={{ justifySelf: 'center', marginRight: '5px' }}
          />
          <span className="heading">{heading}</span>
        </div>
      );
    }
    return <span className="heading">{heading}</span>;
  };

  const user = data?.currentUser;

  return (
    <>
      <Helmet>
        <title>{heading}</title>
      </Helmet>
      <ResponiveLayoutWrapper
        desktopOnly={desktopOnly}
        mobilePadding={mobilePadding}
        className={className}
        heading={heading}
        renderHeading={renderHeading}
        user={user}
      >
        {props.children}
      </ResponiveLayoutWrapper>
    </>
  );
});
